import { render, staticRenderFns } from "./AdminContent.vue?vue&type=template&id=0893f2fc&scoped=true&"
import script from "./AdminContent.vue?vue&type=script&lang=ts&"
export * from "./AdminContent.vue?vue&type=script&lang=ts&"
import style0 from "./AdminContent.vue?vue&type=style&index=0&id=0893f2fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0893f2fc",
  null
  
)

export default component.exports